<template>
	<div>
		<DividerAutoDirection>{{ $t('dashboard.userPulseStats.subHeader.' + service) }}</DividerAutoDirection>
		<Skeleton :paragraph="{ rows: 5 }" :title="false" :loading="loading || data == null">
			<Descriptions v-if="data != null" :column="1" :colon="false" bordered size="small" class="user-pulse-descriptions">
				<DescriptionsItem>
					<template #label>
						<span class="dotted" @click="handleClick('disconnect')">{{ $t('dashboard.userPulseStats.eventGroups.disconnect') }}</span>
					</template>
					<TypographyText><NoLineBreaks>{{ data.disconnect }}</NoLineBreaks></TypographyText>
				</DescriptionsItem>
				<DescriptionsItem>
					<template #label>
						<span class="dotted" @click="handleClick('coords_failure')">{{ $t('dashboard.userPulseStats.eventGroups.coords_failure') }}</span>
					</template>
					<TypographyText><NoLineBreaks>{{ data.coords_failure }}</NoLineBreaks></TypographyText>
				</DescriptionsItem>
				<DescriptionsItem>
					<template #label>
						<span class="dotted" @click="handleClick('other_error')">{{ $t('dashboard.userPulseStats.eventGroups.other_error') }}</span>
					</template>
					<TypographyText><NoLineBreaks>{{ data.other_error }}</NoLineBreaks></TypographyText>
				</DescriptionsItem>
			</Descriptions>
		</Skeleton>
	</div>
</template>

<script>
import { toRef } from 'vue';
import { TypographyText, Descriptions, DescriptionsItem, Skeleton } from 'ant-design-vue';

import DividerAutoDirection from '@/components/common/DividerAutoDirection.vue';
import NoLineBreaks from '@/components/common/NoLineBreaks.vue';

export default {
	components: {
		TypographyText, Descriptions, DescriptionsItem, Skeleton,
		DividerAutoDirection, NoLineBreaks,
	},
	props: {
		data: {
			type: [Object, null],
			required: false,
		},
		service: {
			type: String,
			required: true,
		},
		loading: {
			type: Boolean,
			required: false,
			default: false,
		},
		updateEventsList: {
			type: Function,
			required: true,
		},
	},
	setup(props) {
		const serviceRef = toRef(props, 'service');
		const handleClick = (event) => {
			props.updateEventsList(event, serviceRef.value);
		}
		return {
			handleClick,
		};
	},
}
</script>

<style scoped>
.user-pulse-descriptions {
	background: white;
}
.user-pulse-descriptions .ant-descriptions-item-label span {
	cursor: pointer;
	border-bottom: 1px dotted currentColor;
	text-decoration: none;
}
</style>